import type { FaireProductEntity } from "../../entity_types/product";

export const p_px56kpps3w: FaireProductEntity = {
  token: "p_px56kpps3w",
  type: "product",
  name: "Sanrio Cotton Candy 10x9g (Korea)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/ffb6f4c9dbfbde6782bdeff1f20503247002d48edd249337ff9d205e77bd7a68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/675a3577dcd4353bdc04ab22dbc3fadf91ddd7dde5e9dc4c6a874463ea33961d.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "Sanrio Characters Cotton Candy – Kawaii Korean Treat 🍬🎀🇰🇷\n\nElevate snack time with the whimsical charm of the Sanrio Characters Cotton Candy! This Korean-imported bundle features 10 individually wrapped bags, each with 9 g of fluffy, melt-in-your-mouth cotton candy adorned with beloved Sanrio characters like Hello Kitty, My Melody, and Cinnamoroll. According to the listing, each small size is ideal for a quick sweet treat or a collectible experience.\n\n✅ Official Sanrio licensed candy from Korea\n✅ Fun packaging featuring Sanrio characters for fans and collectors\n✅ Light-and-airy cotton candy texture with a sweet flavor profile\n✅ Format: 10 bags × 9 g — perfect for share packs, party favors, or retail display\n\nSize: 10 × 9 g\nAllergens: Check packaging for details (common candy allergens may include soy or artificial colorings)\n\n✨ Whether you’re stocking a kawaii-snack wall, offering children’s party treats, or adding a collectible item to your confectionery lineup, this Sanrio cotton candy bundle brings sweetness, charm, and share-friendly format.\n",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:00.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
